__turbopack_context__.v({
  "container": "x8gA4a_container",
  "errorMessage": "x8gA4a_errorMessage",
  "field": "x8gA4a_field",
  "input": "x8gA4a_input",
  "inputArea": "x8gA4a_inputArea",
});
